import { render, staticRenderFns } from "./ProfessionView.vue?vue&type=template&id=51d7efa4&scoped=true&"
import script from "./ProfessionView.vue?vue&type=script&lang=js&"
export * from "./ProfessionView.vue?vue&type=script&lang=js&"
import style0 from "./ProfessionView.vue?vue&type=style&index=0&id=51d7efa4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d7efa4",
  null
  
)

export default component.exports